import { Box, Autocomplete, TextField, Typography, Grid, IconButton } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { GenericPopupTooltip } from 'common/components/genericPopupTooltip';
import { RedTheme } from 'common/global';
import { IOSSwitch } from 'common/components/switch';
import { ReactComponent as CrossIcon } from 'common/assets/images/CrossIcon.svg';
import { useScreen } from 'common/hooks/useScreen';
import { NUMBER_ARRAY, USER_PROFILE_LABELS } from 'common/global/constants';
import { useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';

export const GenericAutoCompleteUserProfile = ({
  options,
  values = [],
  switchChangeHandler,
  checked,
  getLabeledOptions,
  handleAutoCompleteChange,
  getEqualityCheck,
  type,
  placeholder,
  heading,
  switchIndicator,
  isSwitchToShow = true,
  validationError = false,
  errorMessage,
  inputWidth = '',
  isFullWidth = true,
  isDisabled = false,
}) => {
  let redtheme = RedTheme;
  const screen = useScreen();
  const [inputValue, setInputValue] = useState('');
  const defaultStyles = {
    fontSize: screen.isTablet ? '20px' : '14px',
    lineHeight: '12px',
    fontWeight: 500,
    fontFamily: '"JohnsonText-Bold"',
    width: inputWidth !== '' ? inputWidth : screen.isMobile || screen.isTablet ? '250px' : '301px',
    height: screen.isTablet ? '25px' : '56px',
    paddingTop: screen.isTablet ? '5px' : NUMBER_ARRAY.zero,
  };

  /**This will add unique key to all options in Autocomplete */
  const getKeyOptions = (option, type) => {
    if (type === USER_PROFILE_LABELS.directReportee) {
      return option.full_name;
    }
  };

  return (
    <>
      {isSwitchToShow ? (
        <Box
          sx={{
            marginLeft: screen.isMobile ? '60%' : screen.isTablet ? '32%' : '90%',
            marginBottom: '-21px',
          }}
        >
          <GenericPopupTooltip title={'Switch to Selected'} placement='top' header={' '}>
            <IOSSwitch checked={checked} onChange={(e) => switchChangeHandler(e, type)} />
          </GenericPopupTooltip>
        </Box>
      ) : null}
      <Autocomplete
        id='generic-auto-complete-user-profile'
        data-testid='generic-auto-complete-user-profile'
        options={switchIndicator ? options : values}
        popupIcon={''}
        getOptionLabel={(option) => getLabeledOptions(option, type)}
        getOptionKey={(option) => getKeyOptions(option, type)}
        isOptionEqualToValue={(option, value) =>
          getEqualityCheck(option, value, type)
        } /* This will show the selected value highlighted on the Search part of Autocomplete */
        renderOption={(props, option) => (
          <li {...props}>
            {!switchIndicator ? (
              <Grid container>
                <Grid item xs={11.5}>
                  {getLabeledOptions(option, type)}
                </Grid>
                <Grid item xs={0.5}>
                  {!switchIndicator ? (
                    <Box>
                      <CrossIcon />
                    </Box>
                  ) : null}
                </Grid>
              </Grid>
            ) : (
              getLabeledOptions(option, type)
            )}
          </li>
        )}
        multiple
        value={values}
        onChange={(e, Value) => {
          handleAutoCompleteChange(e, Value, type);
        }}
        onInputChange={(newValue) => {
          setInputValue((newValue && newValue.target.value) || '');
        }}
        renderInput={(params) => (
          <TextField
            data-testid='generic-auto-complete-textfield'
            {...params}
            InputProps={{
              ...params.InputProps,
              shrink: true,
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {!inputValue ? null : (
                    <IconButton
                      className='generic-autocomplete-clear-icon'
                      onClick={() => {
                        setInputValue('');
                      }}
                    >
                      <ClearIcon sx={{ fontSize: '1.25rem' }} />
                    </IconButton>
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            placeholder={placeholder}
            label={<Typography sx={{...defaultStyles, color: isDisabled ? redtheme.palette.fontColor.light_gray : 'rgba(33, 33, 33, 1)',}}>{heading}</Typography>}
            sx={[
              defaultStyles,
              {
                color: 'rgba(33, 33, 33, 1)',
                borderBottom: `${validationError} ?  1px solid ${redtheme.palette.fontColor.gray_orange} : ''`,
              },
            ]}
            variant='standard'
            margin='normal'
            error={validationError}
            helperText={validationError ? errorMessage : ''}
          />
        )}
        sx={{
          mr: 2,
          width: `${!isFullWidth ? '50%' : '100%'}`,
          '& .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.MuiAutocomplete-clearIndicator':
            { display: inputValue ? 'none' : 'contents' },
          '& .generic-autocomplete-clear-icon': {
            border: 'none',
            backgroundColor: 'white',
            marginRight: values.length > NUMBER_ARRAY.zero ? '-56px' : '-30px',
            color: 'grey',
            cursor: 'pointer',
          },
        }}
        clearOnBlur
        renderTags={() => {}}
        inputValue={inputValue}
        disabled={isDisabled}
      />
    </>
  );
};
